
import { Component, Vue, Prop } from 'vue-property-decorator';
import { titleCompProject } from '@/types/titleComp';
import { homeRecommendPaihang } from '@/config/stat';
@Component
export default class CommonBlockTitle extends Vue {
  // 标题配置 title标题 more是否展示更多
  @Prop() private option!: titleCompProject;
  @Prop() private stat!: () => void;
  toRank() {
    // 需要注意跳转激活对应的swiper 下发到组件去处理
    this.$emit('toRank');
    // 埋点
    if (this.stat) {
      this.stat();
    } else {
      homeRecommendPaihang();
    }
  }
}
